const DRAG_THRESHOLD = 10;

class CardMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.mediaContainer = this.parentElement ? this.parentElement.querySelector('.card__media') : null;
    this.images = this.mediaContainer
      ? Array.from(this.mediaContainer.querySelectorAll('.card-media-slider__image'))
      : [];
    this.dots = Array.from(this.querySelectorAll('.card-media-slider__dot'));
    this.activeIndex = this.images.findIndex((image) => image.classList.contains('is-active'));
    if (this.activeIndex === -1) this.activeIndex = 0;

    this.dragState = null;
    this.suppressNextClick = false;

    this.addEventListener('click', this.handleArrowClick.bind(this));

    if (this.mediaContainer && this.images.length > 1) {
      this.mediaContainer.addEventListener('pointerdown', this.handlePointerDown.bind(this));
      this.mediaContainer.addEventListener('pointermove', this.handlePointerMove.bind(this));
      this.mediaContainer.addEventListener('pointerup', this.handlePointerUp.bind(this));
      this.mediaContainer.addEventListener('pointercancel', this.handlePointerCancel.bind(this));
      this.mediaContainer.addEventListener('click', this.handleMediaClick.bind(this));
    }
  }

  handleArrowClick(event) {
    const nextButton = event.target.closest('.card-media-slider__arrow--next');
    const prevButton = event.target.closest('.card-media-slider__arrow--prev');
    if (!nextButton && !prevButton) return;

    event.preventDefault();
    event.stopPropagation();

    this.goTo(this.activeIndex + (nextButton ? 1 : -1));
  }

  handlePointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    this.dragState = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      dragged: false,
    };
  }

  handlePointerMove(event) {
    if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

    const deltaX = event.clientX - this.dragState.startX;
    const deltaY = event.clientY - this.dragState.startY;

    if (!this.dragState.dragged && Math.abs(deltaX) > DRAG_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
      this.dragState.dragged = true;
      this.mediaContainer.setPointerCapture?.(event.pointerId);
    }

    if (this.dragState.dragged) {
      event.preventDefault();
    }
  }

  handlePointerUp(event) {
    if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

    const deltaX = event.clientX - this.dragState.startX;
    const wasDragged = this.dragState.dragged;
    this.dragState = null;

    if (wasDragged) {
      event.preventDefault();
      if (Math.abs(deltaX) > DRAG_THRESHOLD) {
        this.goTo(this.activeIndex + (deltaX < 0 ? 1 : -1));
      }
      this.suppressNextClick = true;
    }
  }

  handlePointerCancel(event) {
    if (this.dragState && event.pointerId === this.dragState.pointerId) {
      this.dragState = null;
    }
  }

  handleMediaClick(event) {
    if (this.suppressNextClick) {
      this.suppressNextClick = false;
      event.preventDefault();
      event.stopPropagation();
    }
  }

  goTo(index) {
    if (!this.images.length) return;
    this.activeIndex = (index + this.images.length) % this.images.length;
    this.render();
  }

  render() {
    this.images.forEach((image, index) => {
      image.classList.toggle('is-active', index === this.activeIndex);
    });
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === this.activeIndex);
    });
  }
}

if (!customElements.get('card-media-slider')) {
  customElements.define('card-media-slider', CardMediaSlider);
}
